import { useTranslation } from '@/hooks/useTranslation';
import { cn } from '@/lib/utils';

interface LogoProps {
  /**
   * Size variant for the logo
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /**
   * Additional CSS classes
   */
  className?: string;
}

const sizeClasses = {
  sm: 'h-6 w-auto',
  md: 'h-8 w-auto',
  lg: 'h-14 w-auto',
  xl: 'h-18 w-auto',
};

/**
 * Loomis Logo component with configurable size
 */
export default function Logo({ size = 'md', className }: LogoProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex items-center gap-3', className)}>
      {/* Logo Image */}
      <img
        src='/images/logo-loomis.svg'
        alt={t('company.logoAlt')}
        className={cn(sizeClasses[size])}
        loading='eager'
      />
    </div>
  );
}

// Also export the props type for reuse
export type { LogoProps };
